import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthAction from "../../stores/actions/authAction";
import { toast } from "react-toastify";
import { RootState } from "../../stores";
import { LOGO, INDIAN_MSME_USER_TOKEN, LOGIN_BG } from "../../utils/Constants";
import { getCookie } from "../../utils/CookieAction";

const Login = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch()<any>;

  const { authenticated, token } = useSelector(
    (state: RootState) => state.auth
  );

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      await dispatch(AuthAction.signIn({ mobile, password }));
      toast.success("Login Successfully!!");
      setIsLoader(false);
    } catch (e) {
      setIsLoader(false);
      toast.error("Invalid Credentials !");
    }
  };

  useEffect(() => {
    const tokens = getCookie(INDIAN_MSME_USER_TOKEN);
    if ((authenticated && token) || tokens) {
      navigate("/dashboard");
    }
  }, [authenticated, navigate]);

  return (
    <div
      style={{
        height: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      }}>
      <div className={"container"}>
        <div
          className={"row"}
          style={{
            height: "100vh",
            alignItems: "center",
          }}>
          <div
            className={
              "col-lg-4  m-auto d-flex justify-content-center align-items-center"
            }>
            <div className="card">
              <div className="card-body">
                <div className="app-brand justify-content-center">
                  <Link to="/" className="app-brand-link gap-2">
                    <img src={LOGO} alt="logo" width={200} />
                  </Link>
                </div>

                <h4 className="m-2 text-center">Welcome to Indian MSME ! 👋</h4>
                <p className="mb-2 text-center">
                  Please sign-in to your account and start the adventure.
                </p>
                <form
                  id="formAuthentication"
                  className="mb-3 fv-plugins-bootstrap5 fv-plugins-framework"
                  onSubmit={handleLogin}
                  method={"#"}>
                  <div className="mb-3 fv-plugins-icon-container">
                    <label className="mb-2">Mobile No.</label>
                    <input
                      type="text"
                      className="form-control"
                      required={true}
                      value={mobile}
                      onChange={(text) => setMobile(text.target.value)}
                      placeholder="Enter Your Mobile No."
                    />
                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                  </div>
                  <div className="mb-3 form-password-toggle fv-plugins-icon-container">
                    <label className="mb-2">Password</label>
                    <div className="input-group input-group-merge has-validation">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        className="form-control"
                        value={password}
                        onChange={(text) => setPassword(text.target.value)}
                        required={true}
                        placeholder="············"
                        aria-describedby="password"
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}>
                        <i
                          className={`bx ${
                            showPassword ? "bx-show" : "bx-hide"
                          }`}></i>
                      </span>
                    </div>
                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                  </div>
                  <div className="mb-3">
                    <button
                      className="btn btn-primary d-grid w-100 d-flex gap-2"
                      disabled={isLoader}
                      type="submit">
                      {isLoader ? (
                        <i className={"fa fa-spinner fa-spin"}></i>
                      ) : null}
                      Sign in
                    </button>
                  </div>
                  <input type="hidden" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
